import { ITimeZoneDictionaryApi } from '@/types';

export class TimeZoneItem {
    code: string;
    id: number;
    name: string;

    constructor(data: ITimeZoneDictionaryApi) {
        this.id = data.id;
        this.name = data.name;
        this.code = data.code;
    }
}
